import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './plugins'
import VueWait from 'vue-wait'

Vue.config.productionTip = false

Vue.config.errorHandler = (err, vm, info) => {
  // err => the message error
  // vm the exact component where the error occurred 
  // info is error type v-on, lifecycle etc
  console.log('[ERROR CATCH]: ', err)
  console.log('[ERROR COMPONENT]: ', vm)
  console.log('[ERROR INFO]: ', info)
}

new Vue({
  router,
  store,
  wait: new VueWait({
    useVuex: true,
    vuexModuleName: 'wait'
  }),
  render: h => h(App)
}).$mount('#app')
